import { Box } from "@mui/material";
import { CopyLinkButton } from "components/Parts/Atoms/CopyLinkButton";
import { DownloadButton } from "components/Parts/Atoms/DownloadButton";
import React from "react";
import styles from "./DetailPage.module.scss";
import { getPublicUrl } from "./functions";
import { useDetailHooks } from "./hooks";
import { IndividualPage } from "./IndividualPage";
import { DetailProps } from "./interfaces";
import { Styler } from "./subComponents/Styler";

export const DetailPage = React.memo((props: DetailProps) => {
  const {
    publicEstateIds,
    companyIndexes,
    waiting,
    isDownloadingPdf,
    isPdfDownloaded,
    completed,

    onPublicEstateLoaded,
    onCompanyIndexChanged,
    onDownloadPdfClick,
    onCompanyLoadCompleted
  } = useDetailHooks(props);

  if (waiting) {
    return (
      <Box className={styles.waiting}>作成中です。しばらくお待ちください。</Box>
    );
  }

  return (
    <>
      <Box
        className={`${styles.detail} ${props.forAnonymous ? "pubPdfRoot" : ""}`}
      >
        <Styler forAnonymous={props.forAnonymous} />
        <Box className={styles.section} component="section">
          {publicEstateIds.map((publicEstateId, index) => (
            <IndividualPage
              key={index}
              forAnonymous={props.forAnonymous}
              publicEstateId={publicEstateId}
              companyIndex={companyIndexes[index]}
              onPublicEstateLoaded={onPublicEstateLoaded}
              onCompanyIndexChanged={(companyIndex) =>
                onCompanyIndexChanged(index, companyIndex)
              }
              onCompanyLoadCompleted={() => onCompanyLoadCompleted(index)}
            />
          ))}
        </Box>
      </Box>
      {completed ? (
        <Box className={styles.completed} id="completed">
          読み込み完了
        </Box>
      ) : null}
      {props.forAnonymous ? null : (
        <Box className={styles.printButton}>
          <CopyLinkButton
            url={getPublicUrl(window.location.href, companyIndexes)}
            toolTipText={
              <>
                このページのリンクをコピーしました。
                <br />
                コピーリンク閲覧期限：本日より14日間
              </>
            }
          />
          <DownloadButton
            busy={isDownloadingPdf}
            toolTipText="PDFをダウンロードしました"
            completed={isPdfDownloaded}
            onClick={() =>
              onDownloadPdfClick(
                getPublicUrl(window.location.href, companyIndexes)
              )
            }
          />
        </Box>
      )}
    </>
  );
});
